import { Box, Stack, TextField, Typography, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import React from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { get, isArray, isString } from 'lodash';

// Components
import ButtonWithLoading from 'src/components/common/ButtonWithLoading';
import ModalComponent from 'src/components/Modal/ModalComponent';
import FormItemCountryMulti from 'src/components/Form/FormItemCountryMulti';
import FormikForm from 'src/components/common/FormikForm';
import { handleQueryParamFromObject } from 'src/utils/helpers/queryParam';
import { AuthRouteKeys } from 'src/utils/constants/routes';
import { useQueryParams } from 'src/hooks/useQueryParam';
import { TypeFilterPorts } from 'src/utils/typings/dto/tradeData';
import FormItemRegion from 'src/features/ListPorts/Common/FormItemRegion';

interface IProps {
  open: boolean;
  handleClose: () => void;
}

const FormSearchPort: React.FC<IProps> = ({ open, handleClose }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const params = useQueryParams();

  const getDefaultValue = (key: string) => {
    return get(params, key, '') as string;
  };

  const getDefaultArray = (key: string) => {
    const value = params[key];
    if (isArray(value)) {
      return value as ExpectedAny[];
    }
    if (isString(value)) {
      return [value] as string[];
    }
    return [];
  };

  const formik = useFormik<TypeFilterPorts>({
    enableReinitialize: true,
    initialValues: {
      limit: 10,
      offset: 0,
      keyword: getDefaultValue('keyword'),
      country_code: getDefaultArray('country_code'),
      region: getDefaultArray('region'),
    },
    validationSchema: Yup.object().shape({
      country_code: Yup.array(),
      keyword: Yup.string(),
      region: Yup.array(),
    }),
    onSubmit: async (values) => {
      values.country_code = getListCountryCode();
      const params = handleQueryParamFromObject(values);
      navigate({ pathname: AuthRouteKeys.Port, search: params });
      handleClose();
    },
  });

  const getListCountryCode = () => {
    return (formik.values?.country_code || []).map((country) =>
      typeof country === 'string' ? country : get(country, 'code', ''),
    );
  };

  return (
    <ModalComponent padding={4} handleClose={handleClose} open={open}>
      <FormikForm formik={formik}>
        <Box width={540}>
          <Typography textAlign={'center'} variant="h5">
            All Ports
          </Typography>
          <Box sx={{ mt: 1 }} />
          <Typography textAlign={'center'} color={theme.palette.text.secondary} variant="body1">
            Please enter your search critera below.
          </Typography>
          <Typography textAlign={'center'} color={theme.palette.text.secondary} variant="body1">
            The more fields you complete, the more targeted your results will be.
          </Typography>
          <Box sx={{ mt: 4 }} />
          <Stack direction={'column'} spacing={2}>
            <TextField
              id="keyword"
              name="keyword"
              value={get(formik.values, 'keyword', '')}
              size="small"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              fullWidth
              error={Boolean(formik.touched.keyword && formik.errors.keyword)}
              label="Search"
            />
            <FormItemCountryMulti id="country_code" />
            <FormItemRegion id="region" />
            <ButtonWithLoading sx={{ height: 53 }} size="large" variant="contained" isRounded type="submit">
              Search Now
            </ButtonWithLoading>
          </Stack>
        </Box>
      </FormikForm>
    </ModalComponent>
  );
};

export default FormSearchPort;
